import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faXmark } from '@fortawesome/free-solid-svg-icons';
import { P, pillSt } from '../theme/tokens';
import { useHomeScope } from '../hooks/useHomeScope';

const Chip = styled.span`
  gap: 7px;
  button {
    display: inline-flex;
    padding: 0;
    border: none;
    background: none;
    color: inherit;
    cursor: pointer;
  }
`;

export default function ScopeNote() {
  const { active, note, clear } = useHomeScope();
  if (!active) return null;
  return (
    <Chip style={pillSt(P.navy)}>
      <FontAwesomeIcon icon={faLocationDot} style={{ fontSize: 10 }} />
      {note}
      <button type="button" aria-label="Clear Home scope" onClick={clear}>
        <FontAwesomeIcon icon={faXmark} style={{ fontSize: 10 }} />
      </button>
    </Chip>
  );
}
